import type {
  PromotionCenterInfoStoreState,
  PromotionCycleGroups,
  PromotionCycleHistory
} from './types';

export const normalizeCycleGroups = (
  cycleData: PromotionCenterInfoStoreState['cycleData']
): PromotionCycleGroups => (cycleData && !Array.isArray(cycleData) ? cycleData : {});

export const normalizeCycleHistory = (
  cycleHistory: PromotionCenterInfoStoreState['cycleHistory']
): PromotionCycleHistory => (cycleHistory && !Array.isArray(cycleHistory) ? cycleHistory : {});

export const formatPromotionDateRange = (startDate: string, endDate: string): string => {
  const options: Intl.DateTimeFormatOptions = {month: 'long', day: 'numeric'};
  return `${new Date(startDate).toLocaleDateString('fa-IR', options)} - ${new Date(
    endDate
  ).toLocaleDateString('fa-IR', options)}`;
};
